/* eslint-disable react/display-name */
/* eslint-disable react-hooks/exhaustive-deps */
//external imports
import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useAddress from '../../../hooks/useAddress';
import useColumnState from '../../../hooks/useColumnState';
import { useQuery } from 'hooks/useCustomQuery';

import { axios } from '../../../services/axios';
import {
    Flex,
    HStack,
    Tooltip,
    IconButton,
    Text,
    Button,
} from '@chakra-ui/react';

import AddressesCreate from './AddressesCreate';
import AddressesEdit from './AddressesEdit';

import { nullError } from 'components/error';
import { Error } from 'components/index';
import { refreshTable } from 'pages/tpm/AssociatedAccounts/helper';
import { useNavigate } from 'react-router-dom';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import { BsThreeDotsVertical } from 'react-icons/bs';
import Platforms, { PlatformEnums } from '../../../utils/platforms';
import styles from '../../accounts/users/new/cellRenderer/StatusCellRenderer.module.css';
import { Box } from '@chakra-ui/react';

const Addresses = () => {
    const [selectedRowData, setSelectedRowData] = useState();
    const [addressAction, setAddressAction] = useState('Get');
    const [data, setData] = useState([]);
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const { darkMode } = useSelector((state) => state.settings);
    const tableRef = useRef(null);
    const dispatch = useDispatch();

    const { concatAddressFields } = useAddress();
    const navigate = useNavigate();

    function editAddressItem(rowData) {
        console.log(rowData);
        setSelectedRowData(rowData);
        setAddressAction('Edit');
    }

    // Define base column configuration
    const baseAddressColumns = [
        {
            maxWidth: 70,
            width: 70,
            filter: false,
            suppressMovable: true,
            lockVisible: true,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true,
            enableRowGroup: false,
            resizable: false,
            sortable: false,
            cellRenderer: 'agGroupCellRenderer',
            lockPosition: 'left',
        },
        {
            headerName: 'Description',
            field: 'description',
        },
        {
            headerName: 'Address',
            field: 'address',
        },
        // Fields
        {
            headerName: 'Building Type',
            field: 'buildingType',
            hide: true,
        },
        {
            headerName: 'Building 1st Number',
            field: 'building1stNumber',
            hide: true,
        },
        {
            headerName: 'Building 1st Suffix',
            field: 'building1stSuffix',
            hide: true,
        },
        {
            headerName: 'Building 2nd Number',
            field: 'building2ndNumber',
            hide: true,
        },
        {
            headerName: 'Building 2nd Suffix',
            field: 'building2ndSuffix',
            hide: true,
        },
        {
            headerName: 'Building Floor Type',
            field: 'buildingFloorType',
            hide: true,
        },
        {
            headerName: 'Building Floor Number',
            field: 'buildingFloorNumber',
            hide: true,
        },
        {
            headerName: 'Building Floor Number Suffix',
            field: 'buildingFloorNumberSuffix',
            hide: true,
        },
        {
            headerName: 'Building Property',
            field: 'buildingProperty',
            hide: true,
        },
        {
            headerName: 'Building Location',
            field: 'buildingLocation',
            hide: true,
        },
        {
            headerName: 'Street House Number 1',
            field: 'streetHouseNumber1',
            hide: true,
        },
        {
            headerName: 'Street House Number 1 Suffix',
            field: 'streetHouseNumber1Suffix',
            hide: true,
        },
        {
            headerName: 'Street House Number 2',
            field: 'streetHouseNumber2',
            hide: true,
        },
        {
            headerName: 'Street House Number 2 Suffix',
            field: 'streetHouseNumber2Suffix',
            hide: true,
        },
        {
            headerName: 'Street Name 1',
            field: 'streetName1',
            hide: true,
        },
        {
            headerName: 'Street Type 1',
            field: 'streetType1',
            hide: true,
        },
        {
            headerName: 'Street Suffix 1',
            field: 'streetSuffix1',
            hide: true,
        },
        {
            headerName: 'Street Name 2',
            field: 'streetName2',
            hide: true,
        },
        {
            headerName: 'Street Type 2',
            field: 'streetType2',
            hide: true,
        },
        {
            headerName: 'Street Suffix 2',
            field: 'streetSuffix2',
            hide: true,
        },
        {
            headerName: 'Locality',
            field: 'locality',
            hide: true,
        },
        {
            headerName: 'District',
            field: 'district',
            hide: true,
        },
        {
            headerName: 'State',
            field: 'state',
            hide: true,
        },
        {
            headerName: 'Postcode',
            field: 'postcode',
            hide: true,
        },
        {
            headerName: 'Country',
            field: 'country',
            hide: true,
        },
        {
            headerName: 'Google Place ID',
            field: 'googlePlaceID',
            hide: true,
        },
        {
            maxWidth: 100,
            headerName: 'Action',
            filter: false,
            suppressMovable: true,
            lockVisible: true,
            suppressColumnsToolPanel: true,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true,
            enableRowGroup: false,
            resizable: false,
            sortable: false,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
            }),
            lockPosition: 'right',
            cellRenderer: (params) => {
                return (
                    <HStack
                        spacing={0}
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="100%">
                        <Tooltip label="Edit Address">
                            <IconButton
                                icon={
                                    <BsThreeDotsVertical
                                        fill={darkMode ? 'white' : 'black'}
                                    />
                                }
                                aria-label="Edit"
                                variant="ghost"
                                onClick={() => {
                                    editAddressItem(params.data);
                                }}
                                _hover={{
                                    bg: darkMode
                                        ? 'whiteAlpha.200'
                                        : 'blackAlpha.100',
                                }}
                                _active={{
                                    bg: darkMode
                                        ? 'whiteAlpha.300'
                                        : 'blackAlpha.200',
                                }}
                                _focus={{ boxShadow: 'none' }}
                            />
                        </Tooltip>
                    </HStack>
                );
            },
        },
    ];

    // Use the column state hook to manage column visibility
    const { columns: addressColumns, onColumnVisible } =
        useColumnState(baseAddressColumns);

    const { refetch, isRefetching, isFetching, status } = useQuery({
        queryKey: ['addresses'],
        queryFn: async () => {
            const data = await axios.get(`/Addresses/${currentCompany}`);
            return data.data;
        },
        onSuccess: (data) => {
            const addressess = data.map((address) => {
                return {
                    address: concatAddressFields(address),
                    ...address,
                };
            });
            setData(addressess);
            dispatch({
                type: 'CHANGE_TABLE_LOADING',
            });
        },
        refetchOnWindowFocus: false,
    });

    const refreshFn = () => {
        // dispatch({
        //     type: 'CHANGE_TABLE_FILTERING',
        // });
        // tableRef.current &&
        //     tableRef.current.dataManager.columns.forEach((item) => {
        //         tableRef.current.onFilterChange(item.tableData.id, '');
        //     });
        // Returned so AGGridMain's refresh button can await the request and
        // keep its loading overlay up for the real duration.
        return refetch();
    };

    useEffect(() => {
        if (currentCompany) {
            refreshFn();
        }
    }, [addressAction, currentCompany, refreshTable]); // will trigger a refresh, after creating or saving an address

    if (!currentCompany) {
        return (
            <>
                <Error error={nullError} />
            </>
        );
    }

    const titleName = 'Addresses';

    const tableDataObj = {
        columns: addressColumns,
        data: data,
        detailCellRendererParams: {
            detailGridOptions: {
                columnDefs: [
                    {
                        field: 'platformID',
                        headerName: 'Platform',
                        width: 200,
                        flex: 1,
                        cellRenderer: (params) => {
                            const platform = Platforms[params.value];
                            const isEightByEight = platform?.name === '8x8';
                            const displayName =
                                params.value === PlatformEnums.WEBEX
                                    ? 'WebEx Local Gateway'
                                    : platform?.name;
                            return (
                                <Flex align="center" gap={2} height="100%">
                                    <img
                                        src={platform?.icon}
                                        alt={platform?.name}
                                        style={{
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: isEightByEight
                                                ? '50%'
                                                : '0',
                                        }}
                                    />
                                    <Text>{displayName}</Text>
                                </Flex>
                            );
                        },
                        filter: 'agSetColumnFilter',
                        filterValueFormatter: (params) => {
                            return Platforms[params.value]?.name;
                        },
                        filterParams: {
                            valueFormatter: (params) => {
                                return Platforms[params.value]?.name;
                            },
                        },
                        cellStyle: {
                            display: 'flex',
                            alignItems: 'center',
                        },
                    },
                    {
                        field: 'addressID',
                        headerName: 'Location ID',
                        flex: 1,
                    },
                    {
                        field: 'statusDisplay.statusDisplayDetail',
                        headerName: 'Status',
                        width: 200,
                        flex: 1,

                        suppressHeaderMenuButton: true,
                        valueGetter: (params) =>
                            params.data?.statusDisplay?.statusDisplayDetail,
                        cellRenderer: (params) => {
                            const statusDisplay = params.data?.statusDisplay;
                            if (!statusDisplay) return null;

                            const statusLevel =
                                statusDisplay.statusDisplayLevel;
                            const statusText =
                                statusDisplay.statusDisplayDetail;
                            const extendedDetail =
                                statusDisplay.statusDisplayExtended;

                            // Map statusDisplayLevel to type: 0-9=active, 10-19=processing, 20+=inactive
                            const getStatusType = (level) => {
                                if (level >= 0 && level <= 9) return 'active';
                                if (level >= 10 && level <= 19)
                                    return 'processing';
                                return 'inactive';
                            };

                            const statusType = getStatusType(statusLevel);

                            const content = (
                                <Box
                                    className={`${styles.tag} ${styles[statusType + 'Tag']}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                    <div
                                        className={`${styles.circle} ${styles[statusType + 'Circle']}`}
                                    />
                                    <Text isTruncated>{statusText}</Text>
                                </Box>
                            );

                            return extendedDetail ? (
                                <Tooltip
                                    label={extendedDetail}
                                    aria-label="Status tooltip">
                                    {content}
                                </Tooltip>
                            ) : (
                                content
                            );
                        },
                        cellStyle: { display: 'flex', alignItems: 'center' },
                    },
                ],
                defaultColDef: {
                    sortable: true,
                    filter: true,
                    resizable: true,
                    flex: 1,
                    suppressHeaderMenuButton: true,
                },
            },
            getDetailRowData: (params) => {
                params.successCallback(params.data.platformAddresses || []);
            },
        },
    };
    return (
        <>
            {addressAction === 'Get' && (
                <>
                    <Text
                        sx={{
                            fontSize: '20',
                            fontWeight: '500',
                            marginBottom: '15px',
                        }}>
                        Addresses
                    </Text>
                    <AGGridMain
                        gridRef={tableRef}
                        tableData={tableDataObj}
                        masterDetail={true}
                        isRowMaster={(dataItem) => {
                            return (
                                dataItem.platformAddresses &&
                                dataItem.platformAddresses.length > 0
                            );
                        }}
                        detailRowAutoHeight={true}
                        isLoading={status === 'loading'}
                        isFetching={isFetching}
                        isRefetching={isRefetching}
                        titleName={addressAction === 'Get' && titleName}
                        refetch={refreshFn}
                        onColumnVisible={onColumnVisible}
                        extraComponents={
                            <HStack spacing={2} paddingLeft={5}>
                                <Tooltip
                                    label="CSV Update"
                                    placement="bottom"
                                    hasArrow
                                    portalProps={{ containerRef: undefined }}>
                                    <div
                                        style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                        }}>
                                        <Button
                                            size="sm"
                                            width="110px"
                                            onClick={() =>
                                                navigate(
                                                    '/addresses/csv-address',
                                                )
                                            }>
                                            CSV Update
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    label="Add an address"
                                    placement="bottom"
                                    hasArrow
                                    portalProps={{ containerRef: undefined }}>
                                    <div
                                        style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                        }}>
                                        <Button
                                            size="sm"
                                            width="110px"
                                            onClick={() =>
                                                setAddressAction('Create')
                                            }>
                                            Add Address
                                        </Button>
                                    </div>
                                </Tooltip>
                            </HStack>
                        }
                    />
                </>
            )}
            <>
                {addressAction === 'Create' && (
                    <AddressesCreate setAddressAction={setAddressAction} />
                )}
                {addressAction === 'Edit' && (
                    <AddressesEdit
                        setAddressAction={setAddressAction}
                        rowData={selectedRowData}
                    />
                )}
            </>
        </>
    );
};

export default Addresses;
